import { styled } from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1200;
  padding: 3rem;

  @media only screen and (max-width: 1200px) {
    padding: 1rem;
  }
`;

export const HighlightForm = styled.form`
  background: var(--ice);
  border-radius: 10px;
  padding: 2.5rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 600px;
  max-height: calc(100vh - 4rem);
  overflow: auto;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);

  h2 {
    margin-bottom: 2rem;
    color: var(--blue);
  }

  .form-group {
    margin-bottom: 1.5rem;

    label {
      display: block;
      margin-bottom: 0.5rem;
      font-weight: 600;
      color: var(--grey4);
    }

    input {
      width: 100%;
    }
  }

  .image-preview {
    width: 100%;
    height: 200px;
    background: var(--grey7);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    overflow: hidden;
    border: 2px dashed var(--grey6);

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }

    span {
      color: var(--grey5);
    }
  }

  .controls {
    margin-top: 2.5rem;
    display: flex;
    gap: 1.5rem;

    button {
      flex: 1;
    }
  }
`;
